module.exports = __webpack_public_path__ + "img/play.51e525f5.svg";